/**
 * Banner AI Title Generator - Nano GPT-4o-mini
 * Generates short, catchy banner slogans for products
 *
 * @version 1.0.0
 * @author Dolce Vita Halı
 */

(function() {
  'use strict';

  // OpenAI API Configuration - Via Vercel Proxy
  const API_URL = 'https://dolce-openai-proxy.vercel.app/api/openai-nano';
  const MODEL = 'gpt-4o-mini'; // Nano model - fast and cheap

  // Cache configuration
  const CACHE_PREFIX = 'banner_ai_v3_vercel_';
  const CACHE_EXPIRY = 7 * 24 * 60 * 60 * 1000; // 7 days

  /**
   * Initialize banner AI generation
   */
  function init() {
    console.log('🎯 Banner AI Generator v3 initialized (gpt-4o-mini via Vercel proxy)');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processBannerTitles);
    } else {
      processBannerTitles();
    }
  }

  /**
   * Process all banner titles with AI
   */
  function processBannerTitles() {
    const bannerTitles = document.querySelectorAll('[data-banner-ai-title]');

    bannerTitles.forEach(element => {
      const productId = element.dataset.productId;
      const productTitle = element.dataset.productTitle;
      const productTags = element.dataset.productTags ? element.dataset.productTags.split(',') : [];

      if (!productId || !productTitle) return;

      generateBannerTitle(productId, productTitle, productTags, element);
    });
  }

  /**
   * Generate AI banner title
   */
  async function generateBannerTitle(productId, productTitle, productTags, element) {
    // Check cache first
    const cacheKey = CACHE_PREFIX + productId;
    const cached = getCachedTitle(cacheKey);

    if (cached) {
      console.log('✅ Using cached banner title for:', productId);
      element.textContent = cached;
      return;
    }

    try {
      // Build prompt
      const prompt = buildPrompt(productTitle, productTags);

      // Call Vercel Proxy (handles CORS and API key server-side)
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          prompt: 'Sen profesyonel banner copywriter\'ısın. ULTRA KISA (3-8 kelime), ETKİLİ, DİKKAT ÇEKİCİ başlıklar yaz. Satış psikolojisi kullan. Sadece başlığı döndür, başka bir şey yazma!\n\n' + prompt,
          model: MODEL
        })
      });

      if (!response.ok) {
        throw new Error('API error: ' + response.status);
      }

      const data = await response.json();
      const aiTitle = data.choices[0].message.content.trim();

      // Clean up any quotes or extra formatting
      const cleanTitle = aiTitle.replace(/^["']|["']$/g, '').trim();

      // Update element
      element.textContent = cleanTitle;

      // Cache it
      cacheTitle(cacheKey, cleanTitle);

      console.log('✨ AI Banner Title generated:', cleanTitle);

    } catch (error) {
      console.error('❌ Banner AI Error:', error);
      // Keep original title on error
    }
  }

  /**
   * Build prompt for AI
   */
  function buildPrompt(productTitle, productTags) {
    let prompt = '=== BANNER BAŞLIK OLUŞTUR ===\n\n';
    prompt += 'Ürün: ' + productTitle + '\n';

    if (productTags.length > 0) {
      prompt += 'Özellikler: ' + productTags.slice(0, 5).join(', ') + '\n';
    }

    prompt += '\n=== KURALLAR ===\n';
    prompt += '1. ULTRA KISA: Maksimum 3-8 kelime\n';
    prompt += '2. DİKKAT ÇEKİCİ: Müşteri hemen bakmalı\n';
    prompt += '3. ETKİLEYİCİ: Satış psikolojisi kullan\n';
    prompt += '4. AÇIK: Ürün hakkında ne olduğu anlaşılmalı\n';
    prompt += '5. YARATICI: Sıkıcı olma, farklı ol\n\n';
    prompt += '=== ÖRNEKLER ===\n';
    prompt += '❌ Kötü: "Dolce Vita Halı Maison 808 Navy Modern Halı"\n';
    prompt += '✅ İyi: "Modern Zarafet, Evinizde"\n';
    prompt += '✅ İyi: "Konfor ve Stil Bir Arada"\n';
    prompt += '✅ İyi: "Premium Halı, Özel Fiyat"\n\n';
    prompt += 'Şimdi bu ürün için ULTRA KISA ve ETKİLİ bir banner başlığı yaz (sadece başlık, başka bir şey değil):';

    return prompt;
  }

  /**
   * Get cached title
   */
  function getCachedTitle(key) {
    try {
      const cached = localStorage.getItem(key);
      if (!cached) return null;

      const data = JSON.parse(cached);
      const now = new Date().getTime();

      if (now - data.timestamp > CACHE_EXPIRY) {
        localStorage.removeItem(key);
        return null;
      }

      return data.title;
    } catch (e) {
      return null;
    }
  }

  /**
   * Cache title
   */
  function cacheTitle(key, title) {
    try {
      localStorage.setItem(key, JSON.stringify({
        title: title,
        timestamp: new Date().getTime()
      }));
    } catch (e) {
      // Ignore cache errors
    }
  }

  // Initialize
  init();

})();
